export default __webpack_public_path__ + "static/media/Apple_App_store.62854ba0.svg";